


















































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { MessageService } from "@/shared/services/message-service";
import solicitudesWorkflowModule from "@/store/modules/solicitudes-workflow-module";

interface OptionItem {
  value: number | string;
  text: string;
}

@Component({ name: "SolicitudesCitaManager" })
export default class SolicitudesCitaManager extends Vue {
  public loading: boolean = false;
  public saving: boolean = false;
  public savingAction: boolean = false;
  public detalleLoading: boolean = false;
  public searchText: string = "";
  public rows: any[] = [];
  public showCalendar: boolean = true;

  public createDialog: boolean = false;
  public actionDialog: boolean = false;
  public detalleDrawer: boolean = false;
  public jsonDialog: boolean = false;
  public selectedJson: string = "";
  public actionTargetId: number = 0;
  public detalle: any = null;

  public catalogos: any = { centros: [], servicios: [], canales: [], estados: [] };
  public filters: any = { id_centro: null, id_estado: null, solo_conflicto: false, fecha_desde: "", fecha_hasta: "", take: 500 };

  public createForm: any = this.defaultCreateForm();
  public actionForm: any = this.defaultActionForm();

  public calendarFocus: string = "";
  public calendarTitle: string = "";
  public calendarView: string = "month";

  public headers: any[] = [
    { text: "Paciente", value: "paciente", width: "220px" },
    { text: "Centro", value: "centro_nombre", width: "160px" },
    { text: "Servicio", value: "servicio_nombre", width: "180px" },
    { text: "Estado", value: "estado_nombre", width: "170px" },
    { text: "Inicio", value: "fecha_hora_inicio_solicitada", width: "160px" },
    { text: "Conflicto", value: "conflicto_detectado", width: "110px" },
    { text: "Acciones", value: "actions", sortable: false, width: "110px" },
  ];

  public histHeaders: any[] = [
    { text: "Fecha", value: "created_at", width: "160px" },
    { text: "Estado", value: "estado_nombre", width: "150px" },
    { text: "Comentario", value: "comentario" },
    { text: "Actor", value: "cambiado_por_tipo", width: "110px" },
  ];

  public auditHeaders: any[] = [
    { text: "Fecha", value: "created_at", width: "160px" },
    { text: "Tipo", value: "tipo_evento", width: "150px" },
    { text: "Descripción", value: "descripcion" },
    { text: "Actor", value: "actor_tipo", width: "100px" },
    { text: "Datos", value: "datos_json", width: "90px" },
  ];

  public mounted() {
    this.bootstrap();
  }

  public get filteredRows(): any[] {
    const search = (this.searchText || "").toLowerCase().trim();
    if (!search) return this.rows;
    return this.rows.filter((x: any) => {
      const blob = [
        x.uuid, x.paciente_nombre, x.paciente_telefono, x.servicio_nombre, x.estado_nombre, x.motivo_paciente
      ].join(" ").toLowerCase();
      return blob.indexOf(search) !== -1;
    });
  }

  public get calendarEvents(): any[] {
    return this.filteredRows.map((x: any) => {
      const title = (x.paciente_nombre || "Paciente") + " - " + (x.servicio_codigo || x.servicio_nombre || "");
      return {
        name: title,
        start: x.fecha_hora_inicio_solicitada,
        end: x.fecha_hora_fin_solicitada,
        color: this.stateColor(x.estado_codigo),
        solicitudId: x.id,
      };
    });
  }

  public get centroOptions(): OptionItem[] {
    return (this.catalogos.centros || []).map((x: any) => ({ value: x.id, text: x.nombre }));
  }

  public get estadoOptions(): OptionItem[] {
    return (this.catalogos.estados || []).map((x: any) => ({ value: x.id, text: x.nombre }));
  }

  public get estadoCodigoOptions(): OptionItem[] {
    return (this.catalogos.estados || []).map((x: any) => ({ value: x.codigo, text: x.nombre }));
  }

  public get servicioOptionsByCentro(): OptionItem[] {
    const idCentro = Number(this.createForm.id_centro || 0);
    return (this.catalogos.servicios || [])
      .filter((x: any) => Number(x.centro_id) === idCentro)
      .map((x: any) => ({ value: x.id, text: ((x.codigo_elegido || "") + " - " + (x.servicio || "")).trim() }));
  }

  public async bootstrap() {
    this.loading = true;
    try {
      const catalogosResponse = await solicitudesWorkflowModule.getCatalogosAdmin();
      this.catalogos = catalogosResponse && catalogosResponse.data ? catalogosResponse.data : { centros: [], servicios: [], canales: [], estados: [] };
      await this.refreshTablero();
      this.calendarToday();
    } catch (error) {
      MessageService.alert("Error", "No se pudo cargar la configuración de solicitudes", MessageService.TypeError);
    } finally {
      this.loading = false;
    }
  }

  public async refreshTablero() {
    this.loading = true;
    try {
      const response = await solicitudesWorkflowModule.getTableroAdmin(this.filters);
      const data = response && response.data ? response.data : { rows: [] };
      this.rows = data.rows || [];
    } catch (error) {
      MessageService.alert("Error", "No se pudieron cargar las solicitudes", MessageService.TypeError);
    } finally {
      this.loading = false;
    }
  }

  public toggleCalendar() {
    this.showCalendar = !this.showCalendar;
  }

  public calendarToday() {
    const now = new Date();
    const mm = (now.getMonth() + 1).toString().padStart(2, "0");
    const dd = now.getDate().toString().padStart(2, "0");
    this.calendarFocus = now.getFullYear() + "-" + mm + "-" + dd;
    this.calendarTitle = now.toLocaleDateString("es-ES", { month: "long", year: "numeric" });
  }

  public onCalendarViewChanged() {
    const d = this.calendarFocus ? new Date(this.calendarFocus) : new Date();
    this.setCalendarFocus(d);
  }

  public calendarPrev() {
    const d = this.calendarFocus ? new Date(this.calendarFocus) : new Date();
    if (this.calendarView === "month") d.setMonth(d.getMonth() - 1);
    else if (this.calendarView === "week") d.setDate(d.getDate() - 7);
    else d.setDate(d.getDate() - 1);
    this.setCalendarFocus(d);
  }

  public calendarNext() {
    const d = this.calendarFocus ? new Date(this.calendarFocus) : new Date();
    if (this.calendarView === "month") d.setMonth(d.getMonth() + 1);
    else if (this.calendarView === "week") d.setDate(d.getDate() + 7);
    else d.setDate(d.getDate() + 1);
    this.setCalendarFocus(d);
  }

  private setCalendarFocus(d: Date) {
    const mm = (d.getMonth() + 1).toString().padStart(2, "0");
    const dd = d.getDate().toString().padStart(2, "0");
    this.calendarFocus = d.getFullYear() + "-" + mm + "-" + dd;
    if (this.calendarView === "month") {
      this.calendarTitle = d.toLocaleDateString("es-ES", { month: "long", year: "numeric" });
    } else {
      this.calendarTitle = d.toLocaleDateString("es-ES", { weekday: "long", day: "2-digit", month: "long", year: "numeric" });
    }
  }

  public onCalendarEventClick(payload: any) {
    const event = payload && payload.event ? payload.event : payload;
    if (!event) return;
    const id = Number(event.solicitudId || 0);
    if (id > 0) this.openDetalle(id);
  }

  public getCalendarEventColor(event: any): string {
    return event && event.color ? event.color : "blue lighten-5";
  }

  public getActionItems(item: any): Array<{ value: string; label: string }> {
    const allowed = item && item.allowed_actions ? item.allowed_actions : [];
    const map: { [key: string]: string } = {
      marcar_en_revision: "Marcar en revisión",
      confirmar: "Confirmar",
      marcar_enviada_gesden: "Marcar enviada a GESDEN",
      marcar_insertada_gesden: "Marcar insertada en GESDEN",
      marcar_conflicto: "Marcar conflicto",
      marcar_fallida_gesden: "Marcar fallida GESDEN",
      rechazar: "Rechazar",
      cancelar: "Cancelar",
      expirar: "Expirar",
    };

    return (allowed || [])
      .filter((x: string) => !!map[x])
      .map((x: string) => ({ value: x, label: map[x] }));
  }

  public async openDetalle(id: number) {
    this.detalleDrawer = true;
    this.detalleLoading = true;
    this.detalle = null;
    try {
      const response = await solicitudesWorkflowModule.getDetalleAdmin(id);
      this.detalle = response && response.data ? response.data : null;
    } catch (error) {
      MessageService.alert("Error", "No se pudo cargar el detalle de la solicitud", MessageService.TypeError);
    } finally {
      this.detalleLoading = false;
    }
  }

  public openJson(item: any) {
    const raw = item && item.datos_json ? item.datos_json : "";
    if (!raw) {
      this.selectedJson = "{}";
      this.jsonDialog = true;
      return;
    }
    try {
      const parsed = JSON.parse(raw);
      this.selectedJson = JSON.stringify(parsed, null, 2);
    } catch (e) {
      this.selectedJson = raw;
    }
    this.jsonDialog = true;
  }

  public openCreate() {
    this.createForm = this.defaultCreateForm();
    this.createDialog = true;
  }

  public onCentroChanged() {
    this.createForm.id_servicio = 0;
    this.createForm.duracion_minutos = 30;
  }

  public onServicioChanged() {
    const selected = (this.catalogos.servicios || []).find((x: any) => Number(x.id) === Number(this.createForm.id_servicio || 0));
    if (selected && selected.tiempo_minutos && Number(selected.tiempo_minutos) > 0) {
      this.createForm.duracion_minutos = Number(selected.tiempo_minutos);
    }
  }

  public async saveCreate() {
    if (!this.createForm.id_centro || !this.createForm.id_servicio || !this.createForm.fecha || !this.createForm.hora || !this.createForm.duracion_minutos || !this.createForm.nombre || !this.createForm.telefono) {
      MessageService.alert("Validación", "Centro, servicio, fecha, hora, duración, nombre y teléfono son obligatorios", MessageService.TypeWarning);
      return;
    }

    this.saving = true;
    try {
      const payload = {
        id_centro: Number(this.createForm.id_centro),
        id_servicio: Number(this.createForm.id_servicio),
        fecha_hora_inicio_solicitada: this.createForm.fecha + "T" + this.createForm.hora + ":00",
        duracion_minutos: Number(this.createForm.duracion_minutos),
        id_profesional_externo: this.toNullableNumber(this.createForm.id_profesional_externo),
        nombre_profesional: this.createForm.nombre_profesional || "",
        id_cita_externa: this.toNullableNumber(this.createForm.id_cita_externa),
        estado_codigo: this.createForm.estado_codigo || "pendiente",
        canal_codigo: "admin_manual",
        comentario_estado_inicial: "",
        motivo_paciente: this.createForm.motivo_paciente || "",
        notas_internas: this.createForm.notas_internas || "",
        observaciones_admin: this.createForm.observaciones_admin || "",
        nombre: this.createForm.nombre || "",
        apellidos: this.createForm.apellidos || "",
        telefono: this.createForm.telefono || "",
        email: this.createForm.email || "",
        fecha_nacimiento: this.createForm.fecha_nacimiento || null,
        documento: this.createForm.documento || ""
      };

      await solicitudesWorkflowModule.crearAdmin(payload);
      MessageService.toast("Solicitud creada correctamente");
      this.createDialog = false;
      await this.refreshTablero();
    } catch (error) {
      MessageService.alert("Error", "No se pudo crear la solicitud", MessageService.TypeError);
    } finally {
      this.saving = false;
    }
  }

  public openAction(item: any, accion: string) {
    this.actionTargetId = Number(item.id);
    this.actionForm = this.defaultActionForm();
    this.actionForm.accion = accion;
    this.actionForm.id_profesional_externo = item.id_profesional_externo || null;
    this.actionDialog = true;
  }

  public async confirmAction() {
    if (!this.actionTargetId || !this.actionForm.accion) return;
    this.savingAction = true;
    try {
      await solicitudesWorkflowModule.accionAdmin({
        id: this.actionTargetId,
        accion: {
          accion: this.actionForm.accion,
          comentario: this.actionForm.comentario || "",
          id_profesional_externo: this.toNullableNumber(this.actionForm.id_profesional_externo),
          nombre_profesional: this.actionForm.nombre_profesional || "",
          id_cita_externa: this.toNullableNumber(this.actionForm.id_cita_externa),
          observaciones_admin: this.actionForm.observaciones_admin || "",
        },
      });
      MessageService.toast("Acción aplicada correctamente");
      this.actionDialog = false;
      await this.refreshTablero();
    } catch (error) {
      MessageService.alert("Error", "No se pudo aplicar la acción", MessageService.TypeError);
    } finally {
      this.savingAction = false;
    }
  }

  public formatDateTime(value: any): string {
    if (!value) return "-";
    const d = new Date(value);
    if (isNaN(d.getTime())) return String(value);
    const dd = d.getDate().toString().padStart(2, "0");
    const mm = (d.getMonth() + 1).toString().padStart(2, "0");
    const yy = d.getFullYear();
    const hh = d.getHours().toString().padStart(2, "0");
    const mi = d.getMinutes().toString().padStart(2, "0");
    return dd + "/" + mm + "/" + yy + " " + hh + ":" + mi;
  }

  public stateColor(codigo: string): string {
    const c = (codigo || "").toLowerCase();
    if (c === "conflicto" || c === "fallida_gesden") return "red lighten-3";
    if (c === "insertada_gesden") return "green lighten-3";
    if (c === "cancelada" || c === "rechazada" || c === "expirada") return "grey lighten-2";
    if (c === "confirmada" || c === "enviada_gesden") return "blue lighten-3";
    return "amber lighten-3";
  }

  public stateTextColor(codigo: string): string {
    const c = (codigo || "").toLowerCase();
    if (c === "conflicto" || c === "fallida_gesden") return "red darken-3";
    if (c === "insertada_gesden") return "green darken-3";
    if (c === "cancelada" || c === "rechazada" || c === "expirada") return "grey darken-3";
    if (c === "confirmada" || c === "enviada_gesden") return "blue darken-3";
    return "amber darken-3";
  }

  private toNullableNumber(value: any): number | null {
    if (value === null || value === undefined || value === "") return null;
    const n = Number(value);
    if (isNaN(n)) return null;
    return n;
  }

  private defaultCreateForm(): any {
    return {
      id_centro: 0,
      id_servicio: 0,
      estado_codigo: "pendiente",
      fecha: "",
      hora: "",
      duracion_minutos: 30,
      id_profesional_externo: null,
      nombre_profesional: "",
      id_cita_externa: null,
      nombre: "",
      apellidos: "",
      telefono: "",
      email: "",
      fecha_nacimiento: "",
      documento: "",
      motivo_paciente: "",
      notas_internas: "",
      observaciones_admin: "",
    };
  }

  private defaultActionForm(): any {
    return {
      accion: "",
      comentario: "",
      id_profesional_externo: null,
      nombre_profesional: "",
      id_cita_externa: null,
      observaciones_admin: "",
    };
  }
}
